/**
 * @overview 菜单权限
 * @author 3173
 * @date 2019-1
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool ,utils_tool} from '../../../../tool'
import 'antd/dist/antd.css';
import '../../../../styles/containers/auth/menu/index.less';
import { Row, Col } from 'antd';
// import { deepReplaceKey } from "../../../../tool/frameworks/src/components/wizTableList/utils";
let { WizContainer, WizReduxTemplatem, modelUtils } = framework_tool;
let { WizCard, WizLayout, WizIcon, WizMenu, WizTree, WizTable, WizButton, WizCheckbox, WizModal, WizAlert } = component_tool;
const SubMenu = WizMenu.SubMenu;
import { Spin } from 'antd'
import RoleSelect from './roleSelect'
let { checkStrLength, deepReplaceKey } = utils_tool;
import cx from 'classnames';
import { element } from 'prop-types';
class MenuPower extends WizContainer {

  componentName = 'MenuPower';

  constructor(props) {
    super(props);
    this.state = {
      selectModal: false,
      menuName: props.history.location && props.history.location.record ? props.history.location.record.name : null,
      menuId: props.history.location && props.history.location.record ? props.history.location.record.id : null,
      menuElements: [],//菜单对应可选元素
      powerData: [],
      menuType: props.history.location && props.history.location.record ? props.history.location.record.type : 0 ,
      userCount: 0,//用户数量
    }
    this.sumbit = true; //防止多次提交点击
  }

  _componentDidMount() {
    const { history } = this.props;
    this.doActions([
      {
        path: 'menu/getMenus',
        payload: {
          key: 'getMenus',
          apiParams: {
            disabled: 0
          }
        },
        autoInit: true,
      },
    ])
    if (history.location && history.location.record) {
      this.getElements(history.location.record.id);
      this.getMenuRightOfUse(history.location.record.id);
    }
  }

  /**获取菜单对应的元素 */
  getElements(menuId) {
    this.doAction({
      path: 'elements/getElementsByMenuId',
      payload: {
        key: 'getElementsByMenuId',
        apiParams: { menuId: menuId }
      },
      autoInit: true,
    })
  }

  /**保存角色菜单权限 */
  save() {
    if (this.sumbit) {
      this.sumbit = false;
      const list = this.arrange();
      this.doAction({
        path: 'roleMenuElements/batchSave',
        payload: {
          key: 'batchSave',
          apiParams: {
            menuId: this.state.menuId,
            roleMenuElements: list
          }
        },
        autoInit: true,
      })
    }
  }

  /** 通过菜单id获取所有角色及元素权限 */
  getMenuRightOfUse(menuId) {
    this.doAction({
      path: 'roleMenuElements/getMenuRightOfUse',
      payload: {
        key: 'getMenuRightOfUse',
        apiParams: {
          menuId: menuId ? menuId : this.state.menuId
        }
      },
      autoInit: true,
    })
  }

  /**获取角色用户对应的数量 */
  getRoleUsers(powerData) {
    if (this.state.powerData.length > 0 || (powerData && powerData.length > 0)) {
      let roleIds = '';
      if (powerData && powerData.length > 0) {
        powerData.forEach(data => {
          roleIds += data.roleId + ','
        })
      } else {
        this.state.powerData.forEach(data => {
          roleIds += data.roleId + ',';
        })
      }
      roleIds = roleIds.substr(0, roleIds.length - 1);
      this.doAction({
        path: 'roleUser/getPersonIdsByRoleIds',
        payload: {
          key: 'getPersonIdsByRoleIds',
          apiParams: { roleIds: roleIds, time: new Date().getTime() }
        },
        autoInit: true,
      })
    }
  }

  propsAndStateOnChange = {
    seachElements: this._seachElementsOver.bind(this),
    batchSave: this._saveOver.bind(this),
    menuRightOfUse: this._menuRightOfUseTransform.bind(this),
    personIds: this.getRoleUsersOver.bind(this),
    treeMenus: this.getTreeMenusOver.bind(this)
  }

  /**设置当前菜单可以选择的元素 */
  _seachElementsOver(nextProps, nextState) {
    //Checkbox.Group 需要 label显示名 value值
    let menuElements = [];
    nextProps.seachElements && nextProps.seachElements.forEach(
      element => {
        menuElements.push({ label: element.name, value: element.id })
      }
    )
    nextState.menuElements = menuElements;
    return true;
  }

  _saveOver(nextProps, nextState) {
    this.sumbit = true;
    if (nextProps.batchSave.code == 1) {
      wizNotice.success('保存成功');
    } else {
      wizNotice.error('保存失败：' + nextProps.batchSave.msg);
    }
    return true;
  }

  _menuRightOfUseTransform(nextProps, nextState) {
    let neoPowerData = [];
    nextProps.menuRightOfUse && nextProps.menuRightOfUse.data && nextProps.menuRightOfUse.data instanceof Array && nextProps.menuRightOfUse.data.forEach(data => {
      neoPowerData.push({
        menuName: this.state.menuName, //菜单名称
        roleName: data.roleName, //角色名称
        roleId: data.roleId, //角色id
        elementIds: data.elementIds //已选元素id
      })
    })
    nextState.powerData = neoPowerData;
    // if(neoPowerData.length>0){
    //   this.getRoleUsers(neoPowerData);
    // }
    return true;
  }

  getRoleUsersOver(nextProps, nextState) {
    if (nextProps.personIds && nextProps.personIds.length > 0) {
      nextState.userCount = nextProps.personIds.length;
      return true;
    }
    return false;
  }

  getTreeMenusOver(nextProps, nextState) {
    if (nextProps.treeMenus && nextProps.treeMenus.length > 0) {
      let len = 10
        let f = (v) => {
          v && v.forEach(val => {
            val['title'] = checkStrLength(val['title'], len);
            if (val['children'] && val['children'].length > 0) {
              f(val['children'])
            }
          });
        }
        f(nextProps.treeMenus)
      }
  }

    /**把state里的数据处理成对应的关联数据结构给后台保存 */
    arrange() {
      let result = [];
      this.state.powerData.forEach(data => {
        //先增加角色与菜单关联
        result.push({
          menuId: this.state.menuId,
          roleId: data.roleId,
        })
        //增加角色与菜单的元素关联
        data.elementIds.forEach(elementId => {
          if (elementId != 0) {
            result.push({
              menuId: this.state.menuId,
              roleId: data.roleId,
              elementsId: elementId,
            })
          }
        })
      })
      return result;
    }

    /**选择角色后修改列表数据 */
    roleSelect(values) {
      let neoPowerData = Object.assign([], this.state.powerData);
      values && values.forEach(role => {
        neoPowerData.push({
          menuName: this.state.menuName, //菜单名称
          roleName: role.roleName, //角色名称
          roleId: role.roleId, //角色id
          elementIds: [] //已选元素id
        })
      });
      this.setState({ powerData: neoPowerData, selectModal: false })
    }

    /**
     * 树结构节点选择
     * @param {*} selectedKeys
     * @param {*} param1
     */
    nodeOnSelect(selectedKeys, { selected: bool, selectedNodes, node, event }) {
      if (node.props.value === this.state.menuId) {
        this.setState({
          menuName: node.props.title,
        })
      } else {
        this.setState({
          menuName: node.props.title,
          menuId: node.props.value,
          menuElements: [],
          powerData: [],
          userCount: 0,
          menuType: node.props.type
        })

        this.getElements(node.props.value);
        this.getMenuRightOfUse(node.props.value);
      }
    }

    /**移除菜单角色 */
    deleteRole(record) {
      const { powerData } = this.state;
      let neoPowerData = Object.assign([], this.state.powerData);
      for (let i = 0; i < powerData.length; i++) {
        if (powerData[i].roleId === record.roleId) {
          neoPowerData.splice(i, 1);
          break;
        }
      }
      this.setState({ powerData: neoPowerData });
      // this.getRoleUsers(neoPowerData);
    }

    /**修改 */
    onChange(checkedValues, record) {
      const { powerData } = this.state;
      let neoPowerData = Object.assign([], this.state.powerData);
      for (let i = 0; i < powerData.length; i++) {
        if (powerData[i].roleId === record.roleId) {
          neoPowerData[i].elementIds = checkedValues;
          break;
        }
      }
      this.setState({ powerData: neoPowerData });
    }

    /**获取已选择的角色 */
    getSelectedRoleIds() {
      let result = [];
      const { powerData } = this.state;
      powerData.forEach(data => {
        result.push(data.roleId)
      })
      return result;
    }

    /**模态框 */
    roleSelectModal() {
      return (
        <WizModal
          visible={this.state.selectModal}
          onCancel={() => this.setState({ selectModal: false })}
          onOk={() => this.roleRef._selectRoles()}
          style={{ minWidth: 800 }}
          title={'选择角色'}
          key={this.state.menuId}
        >
          <RoleSelect ref={(r) => { this.roleRef = r && r.getWrappedInstance() }} key={new Date()} menuId={this.state.menuId} selectedIds={this.getSelectedRoleIds()} roleSelect={this.roleSelect.bind(this)} />

        </WizModal>
      )
    }


    _render() {
      const { history } = this.props;
      let initialSelected = history.location && history.location.record ? history.location.record.id : null;
      const columns = [
        {
          title: '菜单',
          dataIndex: 'menuName',
          key: 'menuName',
          width: 100
        },
        {
          title: '角色',
          dataIndex: 'roleName',
          key: 'roleName',
          width: 150
        },
        {
          title: '元素权限',
          dataIndex: 'elements',
          key: 'elements',
          width: 300,
          render: (text, record) => {
            if (this.state.menuType == 0 || this.state.menuElements.length==0) {
              return null
            } else {
              return <WizCheckbox.Group key={record.roleId} options={this.state.menuElements} defaultValue={record.elementIds} onChange={(checkedValues) => this.onChange(checkedValues, record)} />
            }
          },
        },
        {
          title: '操作',
          key: 'action',
          render: (text, record) => (
            <WizButton type="link" className="button" onClick={this.deleteRole.bind(this, record)}>删除</WizButton>
          ),
        },
      ];

      let message = (<React.Fragment><span className="tips-font">当前已选菜单： </span> <span className="tips-deepen-font">{this.state.menuName} </span>  <span className="tips-right">已设置 {this.state.powerData.length} 个角色</span> </React.Fragment>);
      return (
        <Spin tip={'加载中'} spinning={this.props.menuLoading || this.props.elementsLoading || this.props.roleMenuElementsLoading || this.props.roleUserLoading || this.props.roleLoading}>
          <WizCard  className='menu-item'>
            <WizLayout key={this.componentName + '@Layout'}>
              <WizLayout.Header>
                <Row>
                  <Col span={2} >
                    <WizIcon type="question-circle" />
                    <span className="header-icon-font">设置说明</span>
                  </Col>
                  <Col span={22} push={1}>
                    <div className="header-font">1、请点击需要设置权限的导航菜单节点。</div>
                    <div className="header-font">2、然后设置对应角色及元素权限,设置后表示该角色下的用户可以在导航中看到此菜单且可操作对应元素功能。</div>
                    <div className="header-deepen-font">3、设置后的权限需要用户重新登录才会生效。</div>
                  </Col>
                </Row>

                {this.state.menuName ?
                  <WizAlert
                    type="info"
                    message={message}
                    showIcon
                    style={{ marginTop: 15 }}
                  />
                  : null}

              </WizLayout.Header>


            </WizLayout>

            <WizLayout className="sider-layout" >
              <WizLayout.Sider width={236} collapsedWidth={236} trigger={null} breakpoint="lg" collapsible={false} className="sider">
                <div className="sider-header"><WizIcon type="unordered-list" /> <span className="sider-header-font"> 菜单</span></div>
            {this.props.treeMenus && this.props.treeMenus.length>0 ?
                <WizTree style={{ maxWidth: 234 ,overflow:'auto'}} onSelect={this.nodeOnSelect.bind(this)} autoExpandParent={true} defaultExpandParent={true} defaultExpandedKeys={[this.state.menuId+'']} defaultSelectedKeys={[this.state.menuId+'']}  treeData={deepReplaceKey(this.props.treeMenus ? this.props.treeMenus : [], [{ key: "parentId", value: "key" }])} />
            : null  }
                </WizLayout.Sider>
              <WizLayout.Content className="content" >
                {this.state.menuName ?
                  <div className="content-div">
                    <WizTable columns={columns} dataSource={this.state.powerData} />

                    <WizButton icon="plus" type="primary" size="small" className="push-button" onClick={() => this.setState({ selectModal: true })}>添加</WizButton>
                    <div className="sumbit-btns">
                      <WizButton type="primary" className="button" onClick={this.save.bind(this)}>保存</WizButton>
                      <WizButton className="button" onClick={() => this.setState({ menuName: null })}>取消</WizButton>
                    </div>
                  </div>
                  : null}
              </WizLayout.Content>
            </WizLayout>
          </WizCard>
          {this.roleSelectModal()}
        </Spin>
      )
    }
  }

  const mapStateToProps = (state, ownProps) => {
    const { menu, elements, roleMenuElements, roleUser,role } = state;
    const treeMenus = modelUtils.getModelEntity(menu, "getMenus");
    const seachElements = modelUtils.getModelEntity(elements, "getElementsByMenuId");
    const batchSave = modelUtils.getModelEntity(roleMenuElements, "batchSave");
    const getMenuRightOfUse = modelUtils.getModelEntity(roleMenuElements, "getMenuRightOfUse");
    const getPersonIdsByRoleIds = modelUtils.getModelEntity(roleUser, "getPersonIdsByRoleIds");
    const load = modelUtils.getLoadingState(state, ['elements', 'menu', 'roleMenuElements','roleUser','role']);
    return {
      treeMenus: treeMenus.data,
      seachElements: seachElements.data,
      batchSave: batchSave,
      menuRightOfUse: getMenuRightOfUse,
      personIds: getPersonIdsByRoleIds.data,
      ...load
    }
  };

  export default connect(mapStateToProps)(MenuPower);
